import { SingleSelectField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { EventParticipationStatus } from "../types/event";

interface Props {
	name: string;
	label: string;
	required?: boolean;
}

const options: EventParticipationStatus[] = ["none", "withParticipation", "noParticipation"];

export const EventParticipationStatusSelectField: FC<Props> = (props) => {
	const { t } = useTranslation();

	return (
		<SingleSelectField {...props} options={options} getLabel={(option) => t(`eventParticipationStatus.${option}`)} />
	);
};
